import {allShotsCsv} from './api'

(async function() {
    allShotsCsv((res) => {
        const url = window.URL.createObjectURL(res);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = 'golf-shots.csv';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    }, "Sorry there was an issue downloading your file.")
})();